import { G, Path, Svg } from "@react-pdf/renderer"

export const MapIconPDF: React.FC = () => {
	return (
		<Svg width="16" height="16" viewBox="0 0 16 16" fill="white">
			<G opacity="0.5">
				<Path
					d="M13.3332 6.66671C13.3332 10.6667 7.99984 14.6667 7.99984 14.6667C7.99984 14.6667 2.6665 10.6667 2.6665 6.66671C2.6665 5.25222 3.22841 3.89567 4.2286 2.89547C5.22879 1.89528 6.58535 1.33337 7.99984 1.33337C9.41432 1.33337 10.7709 1.89528 11.7711 2.89547C12.7713 3.89567 13.3332 5.25222 13.3332 6.66671Z"
					stroke="#020617"
					stroke-width="1.33"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<Path
					d="M8 8.66663C9.10457 8.66663 10 7.7712 10 6.66663C10 5.56206 9.10457 4.66663 8 4.66663C6.89543 4.66663 6 5.56206 6 6.66663C6 7.7712 6.89543 8.66663 8 8.66663Z"
					stroke="#020617"
					stroke-width="1.33"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</G>
		</Svg>
	)
}
